// HeroSection.jsx
import { useEffect, useRef } from "react";
import { Navbar2 } from "./C_Mobile.jsx";

export default function HeroSection() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animId;
    let particles = [];

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };

    // Particles spawn near the bottom and drift upward, fading out before the top
    const makeParticle = (forceBottom = false) => {
    //   const y = forceBottom
    //     ? canvas.height + Math.random() * 40
    //     : canvas.height * 0.55 + Math.random() * (canvas.height * 0.5);
    const y = Math.random() * canvas.height;
      return {
        x: Math.random() * canvas.width,
        y,
        size: Math.random() * 2.2 + 0.5,
        opacity: Math.random() * 0.55 + 0.15,
        speed: Math.random() * 0.35 + 0.06,
        drift: (Math.random() - 0.5) * 0.18,
      };
    };

    resize();
    particles = Array.from({ length: 110 }, () => makeParticle(false));

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((p) => {
        p.y -= p.speed;
        p.x += p.drift;

        // Fade out as they rise toward the top half
        const fadeStart = canvas.height * 0.55;
        if (p.y < fadeStart) {
          p.opacity -= 0.0022;
        } else {
          // slight flicker/breathe near bottom
          p.opacity -= 0.0004;
        }

        // Reset when invisible or off-screen
        if (p.opacity <= 0 || p.y < -5) {
          Object.assign(p, makeParticle(true));
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(220,230,240,${Math.max(0, p.opacity)})`;
        ctx.fill();
      });

      animId = requestAnimationFrame(animate);
    };

    animate();
    window.addEventListener("resize", resize);

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className="text-white position-relative z-index-1 content">
      <Navbar2 />

      <div
        className="container-fluid min-vh-100 d-flex align-items-center position-relative overflow-hidden"
        style={{ 
            // background: "#0a0a0a" 
        }}
      >
        {/* Canvas — particles */}
        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
        />

        {/* Faded grid overlay — stronger at top, fades toward bottom */}
        {/* <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            pointerEvents: "none",
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            // Mask fades the grid out toward the bottom so particles feel "above" the grid
            WebkitMaskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 100%)",
            maskImage:
              "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 100%)",
          }}
        /> */}

        {/* Content */}
        <div
          className="w-100 d-flex flex-column align-items-center justify-content-center text-center"
          style={{ position: "relative", zIndex: 2 }}
        >
          <h1
            className="hero-text text-white text-center"
            data-aos="fade-right"
            data-aos-delay="2200"
            style={{ fontSize: "clamp(1.8rem, 4vw, 3rem)", marginBottom: "0.4rem" }}
          >
            Your Look Starts Here.
          </h1>
          <p
            className="sub-text text-white text-center"
            data-aos="fade-left"
            data-aos-delay="2200"
            style={{ fontSize: "clamp(0.9rem, 2vw, 1.3rem)", marginBottom: "2rem" }}
          >
            The World Can Wait.
          </p>

          <div
            className="d-flex justify-content-center gap-3"
            data-aos="fade-up"
            data-aos-delay="2200"
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                padding: "10px",
                color: "white",
              }}
            >
              <a
                href="https://web.getsquire.com/brands/the-lobby"
                className="btn btn-dark btn-lg rounded-pill px-4 py-3 shadow-lg transform-hover"
                style={{
                  display: "inline-block",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  color: "white",
                  borderRadius: "50px",
                  padding: "0.85rem 2.8rem",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  border: "1px solid rgba(255,255,255,0.3)",
                  transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                  backdropFilter: "blur(4px)",
                  textDecoration: "none",
                }}
              >
                BOOK NOW
              </a>

              <a
                href="/#Services2"
                className="btn btn-dark btn-lg rounded-pill px-4 py-3 shadow-lg transform-hover"
                style={{
                  display: "inline-block",
                  backgroundColor: "rgba(0,0,0,0.4)",
                  color: "white",
                  borderRadius: "50px",
                  padding: "0.85rem 2.8rem",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  border: "1px solid rgba(255,255,255,0.6)",
                  transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                  backdropFilter: "blur(4px)",
                  textDecoration: "none",
                }}
              >
                Services
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}